export default __webpack_public_path__ + "static/media/218.6e066820.jpg";